import {BrowserModule, BrowserTransferStateModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {JwtInterceptor} from './_services/auth/jwt.interceptor';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {UploadFileComponent} from './components/upload-file/upload-file.component';
import {LoginComponent} from './components/auth/login/login.component';
import {RegisterUserComponent} from './components/auth/register-user/register-user.component';
import {MainComponent} from './components/main/main.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {DocumentComponent} from './components/shared/document/document.component';
import {FileUploadModule} from 'ng2-file-upload';
import {SanitizeHtmlPipe} from './_pipes/sanitize-html.pipe';
import {MaterialModule} from './material.module';
import {FileSizePipe} from './_pipes/file-size.pipe';
import {TextDocumentItemComponent} from './components/shared/text-document-item/text-document-item.component';
import {BrowseFilesComponent} from './components/browse-files/browse-files.component';
import {ProgressBarComponent} from './components/shared/progress-bar/progress-bar.component';
import {StatusIconComponent} from './components/shared/status-icon/status-icon.component';
import {ChipComponent} from './components/shared/chip/chip.component';
import {ChipRowComponent} from './components/shared/document/chip-row/chip-row.component';
import {EntitiesBarComponent} from './components/shared/document/entities-bar/entities-bar.component';
import {EntitiesBarRowComponent} from './components/shared/document/entities-bar/entities-bar-row/entities-bar-row.component';
import {PageIndicatorComponent} from './components/shared/document/page-indicator/page-indicator.component';
import {AlertComponent} from './components/shared/alert/alert.component';
import {LoaderComponent} from './components/shared/loader/loader.component';
import {MagnifyingGlassComponent} from './components/shared/document/magnifying-glass/magnifying-glass.component';
import {VideoFileItemComponent} from './components/shared/video-file-item/video-file-item.component';
import {ImageFileItemComponent} from './components/shared/image-file-item/image-file-item.component';
import {FilterPipe} from './_pipes/filter.pipe';
import {FilterFilesComponent} from './components/browse-files/filter-files/filter-files.component';
import {ImagePreloadDirective} from './_directives/image-preload.directive';
import {InnerHTMLComponent} from './components/shared/document/inner-html/inner-html.component';
import {ScrollSpyDirective} from './_directives/scroll-spy.directive';
import {ConfirmationDialogComponent} from './components/shared/confirmation-dialog/confirmation-dialog.component';
import {LoadingDialogComponent} from './components/shared/loading-dialog/loading-dialog.component';
import {LoaderPackingFilesComponent} from './components/shared/loader-packing-files/loader-packing-files.component';
import {LoaderFilesComponent} from './components/shared/loader-files/loader-files.component';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {AnoFileNamePipe} from './_pipes/ano-file-name.pipe';

import {AnonymizationStatusComponent} from './components/upload-file/anonymization-status/anonymization-status.component';
import {SpinnigInfinityLoaderComponent} from './components/shared/spinnig-infinity-loader/spinnig-infinity-loader.component';
import {LoaderDeleteFilesComponent} from './components/shared/loader-delete-files/loader-delete-files.component';
import {RoundCheckboxComponent} from './components/shared/round-checkbox/round-checkbox.component';
import {SecurePipe} from './_pipes/secure.pipe';
import {HoursMinutesSecondsPipe} from './_pipes/hours-minutes-seconds.pipe';
import {DicomFileItemComponent} from './components/shared/dicom-file-item/dicom-file-item.component';
import {SimpleDialogComponent} from './components/shared/simple-dialog/simple-dialog.component';
import {MainWithoutBarComponent} from './components/main-without-bar/main-without-bar.component';
import {StatusRadialBarComponent} from './components/shared/status-radial-bar/status-radial-bar.component';
import {Span3dotComponent} from './components/shared/span3dot/span3dot.component';
import {SettingsComponent} from './components/settings/settings.component';
import {ImageModelChooserComponent} from './components/settings/image-model-chooser/image-model-chooser.component';
import {ImageModelItemComponent} from './components/settings/image-model-chooser/image-model-item/image-model-item.component';
import {BrokenFileComponent} from './components/shared/broken-file/broken-file.component';
import {SmallPageNavigatorComponent} from './components/shared/small-page-navigator/small-page-navigator.component';
import {LastPagePipe} from './_pipes/last-page.pipe';
import {
  VideoImageNewEntityButtonComponent
} from './components/shared/video-image-new-entity-button/video-image-new-entity-button.component';
import {VideoImageEntityItemComponent} from './components/shared/video-image-entity-item/video-image-entity-item.component';

import {AsyncPipe} from '@angular/common';
import {SortByPipe} from './_pipes/sort-by.pipe';
import {LoginByTokenComponent} from './components/auth/login-by-token/login-by-token.component';
import {InactiveComponent} from './components/auth/inactive/inactive.component';
import {WhiteCardComponent} from './components/main-without-bar/white-card/white-card.component';
import {MultipleSelectionBanerComponent} from './components/browse-files/multiple-selection-baner/multiple-selection-baner.component';
import {ResetPasswordComponent} from './components/auth/reset-password/reset-password.component';
import {ResetPasswordConfirmComponent} from './components/auth/reset-password-confirm/reset-password-confirm.component';
import {ChangePasswordComponent} from './components/change-password/change-password.component';
import {FirstLoginComponent} from './components/auth/first-login/first-login.component';
import {ChangePasswordFormComponent} from './components/shared/change-password-form/change-password-form.component';
import {CreateShareFilesDialogComponent} from './components/shared/create-share-files-dialog/create-share-files-dialog.component';
import {TransfersViewComponent} from './components/transfers-view/transfers-view.component';
import {DownloadShareFileViewComponent} from './components/download-share-file-view/download-share-file-view.component';
import {ShareItemComponent} from './components/transfers-view/share-item/share-item.component';
import {
  ShareItemSelectionBanerComponent
} from './components/transfers-view/share-item-selection-baner/share-item-selection-baner.component';
import {SeeDetailsComponent} from './components/transfers-view/share-item/see-details/see-details.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import {DicomParserHelper} from './_services/dicom/dicom-parser.helper';
import {UploadingFileStatusToNumberPipe} from './_pipes/uploading-file-status-to-number.pipe';
import {UploadingFileStatusToLabelPipe} from './_pipes/uploading-file-status-to-label.pipe';
import {RoundDownPipe} from './_pipes/round-down.pipe';
import {CurrentDateTimePipe} from './_pipes/current-date-time.pipe';
import {UploadErrorDialogComponent} from './components/shared/upload-error-dialog/upload-error-dialog.component';
import {RequestsListViewComponent} from './components/requests-list-view/requests-list-view.component';
import {UploadRequestedFilesComponent} from './components/upload-requested-files/upload-requested-files.component';
import {CreateFileRequestDialogComponent} from './components/shared/create-file-request-dialog/create-file-request-dialog.component';
import {RequestItemComponent} from './components/requests-list-view/request-item/request-item.component';
import {
  RequestItemSelectionBanerComponent
} from './components/requests-list-view/request-item-selection-baner/request-item-selection-baner.component';


@NgModule({
  declarations: [
    AppComponent,
    UploadFileComponent,
    LoginComponent,
    RegisterUserComponent,
    MainComponent,
    DocumentComponent,
    SanitizeHtmlPipe,
    FileSizePipe,
    TextDocumentItemComponent,
    BrowseFilesComponent,
    ProgressBarComponent,
    StatusIconComponent,
    ChipComponent,
    ChipRowComponent,
    EntitiesBarComponent,
    EntitiesBarRowComponent,
    PageIndicatorComponent,
    AlertComponent,
    LoaderComponent,
    MagnifyingGlassComponent,
    VideoFileItemComponent,
    ImageFileItemComponent,
    FilterPipe,
    FilterFilesComponent,
    ImagePreloadDirective,
    InnerHTMLComponent,
    ScrollSpyDirective,
    ConfirmationDialogComponent,
    LoadingDialogComponent,
    LoaderPackingFilesComponent,
    LoaderFilesComponent,
    AnoFileNamePipe,
    AnonymizationStatusComponent,
    SpinnigInfinityLoaderComponent,
    LoaderDeleteFilesComponent,
    RoundCheckboxComponent,
    SecurePipe,
    HoursMinutesSecondsPipe,
    DicomFileItemComponent,
    SimpleDialogComponent,
    MainWithoutBarComponent,
    StatusRadialBarComponent,
    Span3dotComponent,
    SettingsComponent,
    ImageModelChooserComponent,
    ImageModelItemComponent,
    BrokenFileComponent,
    SmallPageNavigatorComponent,
    LastPagePipe,
    VideoImageNewEntityButtonComponent,
    VideoImageEntityItemComponent,
    SortByPipe,
    LoginByTokenComponent,
    InactiveComponent,
    WhiteCardComponent,
    MultipleSelectionBanerComponent,
    ResetPasswordComponent,
    ResetPasswordConfirmComponent,
    ChangePasswordComponent,
    FirstLoginComponent,
    ChangePasswordFormComponent,
    CreateShareFilesDialogComponent,
    TransfersViewComponent,
    DownloadShareFileViewComponent,
    ShareItemComponent,
    ShareItemSelectionBanerComponent,
    SeeDetailsComponent,
    UploadingFileStatusToNumberPipe,
    UploadingFileStatusToLabelPipe,
    RoundDownPipe,
    CurrentDateTimePipe,
    UploadErrorDialogComponent,
    RequestsListViewComponent,
    UploadRequestedFilesComponent,
    CreateFileRequestDialogComponent,
    RequestItemComponent,
    RequestItemSelectionBanerComponent
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'blueGDPR'}),
    BrowserTransferStateModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgbModule,
    HttpClientModule,
    FileUploadModule,
    MaterialModule,
    ReactiveFormsModule,
    MatDialogModule,
    PdfViewerModule,
    FormsModule,
    // VgCoreModule,
    // VgControlsModule,
    // VgOverlayPlayModule,
    // VgBufferingModule
  ],
  providers: [
    LastPagePipe, SecurePipe, AsyncPipe, DeviceDetectorService, DicomParserHelper,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    {
      provide: MatDialogRef,
      useValue: {}
    }
    ],
  bootstrap: [AppComponent],
  entryComponents: [ConfirmationDialogComponent, LoadingDialogComponent, SimpleDialogComponent, CreateShareFilesDialogComponent, CreateFileRequestDialogComponent]
})
export class AppModule { }
